import { render, staticRenderFns } from "./index.vue?vue&type=template&id=eca10f1a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=eca10f1a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eca10f1a')) {
      api.createRecord('eca10f1a', component.options)
    } else {
      api.reload('eca10f1a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=eca10f1a", function () {
      api.rerender('eca10f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/head/index.vue"
export default component.exports